// Successful playback responses are URLs. Never hand an error body to the media player.
export function validateChannelPlayback(response) {
  const value = response?.data;
  if (typeof value === "string" && value.includes("Customer can't access this url.")) {
    const error = new Error("CHANNEL_NOT_ENTITLED");
    error.code = "CHANNEL_NOT_ENTITLED";
    throw error;
  }
  const url = typeof value === "string" ? value.trim().replace(/(https?):\s+\/\//i, "$1://") : "";
  let valid = false;
  try {
    const parsed = new URL(url, "https://atlas.invalid");
    valid = !!url && (/^https?:\/\//i.test(url) || /^\/(?!\/)/.test(url)) &&
      ["http:", "https:"].includes(parsed.protocol) && parsed.hostname !== "sample.vod.url";
  } catch (_) { /* A malformed response is a stream failure. */ }
  if (!valid) {
    const error = new Error("CHANNEL_STREAM_UNAVAILABLE");
    error.code = "CHANNEL_STREAM_UNAVAILABLE";
    throw error;
  }
  return { ...response, data: url };
}

export function channelPlaybackError(error) {
  const data = error?.response?.data;
  const message = typeof data === "string" ? data : data?.Message || error?.message;
  if (message === "CHANNEL_LOCKED" || error?.code === "CHANNEL_LOCKED") return { code: 303 };
  const denied = error?.code === "CONTENT_UNAVAILABLE" || error?.code === "CHANNEL_NOT_ENTITLED" ||
    message === "CHANNEL_NOT_ENTITLED" || message?.includes("Customer can't access this url.");
  return { code: denied ? 302 : 503 };
}

export const isChannelOutsidePackage = channel => {
  if (["5", "-1"].includes(channel?.auth_returncode)) return true;
  const locked = channel?.interactions?.includes("CHANNEL_LOCK") ||
    channel?.islocked === "1" || channel?.isLocked === true;
  // canWatch includes the profile lock; auth_returncode still describes the package.
  const entitledLock = channel?.auth_returncode === "0" && locked;
  return channel?.canWatch === false && !entitledLock;
};
